import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Trash2, Home, Heart, HandHeart, Refrigerator, Sofa, HardHat, TreePine } from 'lucide-react';
import { SERVICES } from '@/data/site';

const ICON_MAP = { Trash2, Home, Heart, HandHeart, Refrigerator, Sofa, HardHat, TreePine };

export default function ServicesGrid() {
  return (
    <section className="section-pad bg-ohana-bg" data-testid="home-services">
      <div className="container-ohana">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <p className="overline">What We Do</p>
            <h2 className="h-display text-4xl md:text-5xl mt-3">
              Every kind of cleanout, <em className="not-italic text-ohana-accent">handled.</em>
            </h2>
          </div>
          <p className="text-ohana-text-muted max-w-md text-base">
            From a single pickup to a whole-property reset, we are the team Central Indiana calls when stuff has to go.
          </p>
        </div>

        <div className="grid grid-cols-12 gap-5 md:gap-6">
          {SERVICES.map((s, i) => {
            const Ico = ICON_MAP[s.icon];
            const span = s.feature
              ? 'col-span-12 md:col-span-6 lg:col-span-6'
              : 'col-span-12 sm:col-span-6 lg:col-span-4';
            const isDark = i === 0 || i === 4; // alternate darks for visual rhythm
            return (
              <Link
                key={s.slug}
                to={`/${s.slug}`}
                className={`${span} group relative overflow-hidden rounded-2xl border transition-all duration-300 hover:-translate-y-1 ${
                  isDark
                    ? 'bg-ohana-primary text-ohana-bg border-ohana-primary hover:shadow-2xl hover:shadow-ohana-primary/20'
                    : 'bg-white border-ohana-border hover:shadow-xl hover:shadow-ohana-primary/5'
                } p-7 flex flex-col min-h-[220px]`}
                data-testid={`service-card-${s.slug}`}
              >
                <div className="flex items-start justify-between">
                  <span
                    className={`grid h-12 w-12 place-items-center rounded-xl ${
                      isDark ? 'bg-ohana-accent text-white' : 'bg-ohana-surface text-ohana-primary'
                    }`}
                  >
                    {Ico && <Ico className="h-6 w-6" />}
                  </span>
                  <ArrowUpRight
                    className={`h-5 w-5 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1 ${
                      isDark ? 'text-ohana-accent' : 'text-ohana-primary'
                    }`}
                  />
                </div>
                <h3
                  className={`mt-6 font-serif text-2xl md:text-3xl leading-tight ${
                    isDark ? 'text-ohana-bg' : 'text-ohana-primary'
                  }`}
                >
                  {s.title}
                </h3>
                <p
                  className={`mt-3 text-sm md:text-base leading-relaxed ${
                    isDark ? 'text-ohana-bg/75' : 'text-ohana-text-muted'
                  }`}
                >
                  {s.short}
                </p>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
